import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';

export const Title = styled.p`
  ${fontTitle(16)};
  color: var(--foreground);
  padding: 6px 0 6px 0;
  margin: 0;
`;

export const List = styled.ul`
  ${fontBody(14)}
  list-style-type: none;
  padding-left: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  color: var(--foreground);
  padding-top: 8px;
  padding-bottom: 6px;
  a:visited {
    color: var(--foreground);
  }
`;

export const Link = styled.a`
  text-decoration: none;
  color: var(--foreground);

  a:visited {
    color: var(--foreground);
  }

  &:hover {
    text-decoration: underline;
  }
`;
